import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from "../button/button.component";
import { ModalComponent } from "../modal/modal.component";

@Component({
  selector: 'app-payment-page',
  imports: [CommonModule, RouterLink, ButtonComponent, ModalComponent],
  templateUrl: './payment-page.component.html',
  styleUrl: './payment-page.component.css'
})
export class PaymentPageComponent {
activeSection: string | null = null;

openSection(section: string) {
  this.activeSection = section;
}
printReceipt() {
  window.print();
}

}
